var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppstore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_950_676)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4993 51.6671C38.1457 51.6671 37.8066 51.5267 37.5565 51.2766C37.3065 51.0266 37.166 50.6874 37.166 50.3338C37.166 49.9802 37.3065 49.641 37.5565 49.391C37.8066 49.1409 38.1457 49.0005 38.4993 49.0005H52.4993C53.8327 49.0005 55.166 51.6671 54.4993 51.6671H38.4993ZM57.166 51.6671C56.8124 51.6671 56.4733 51.5267 56.2232 51.2766C55.9732 51.0266 55.8327 50.6874 55.8327 50.3338C55.8327 49.9802 55.9732 49.641 56.2232 49.391C56.4733 49.1409 56.8124 49.0005 57.166 49.0005H62.4993C62.853 49.0005 63.1921 49.1409 63.4422 49.391C63.6922 49.641 63.8327 49.9802 63.8327 50.3338C63.8327 50.6874 63.6922 51.0266 63.4422 51.2766C63.1921 51.5267 62.853 51.6671 62.4993 51.6671H57.166ZM51.3433 33.6685C51.5198 33.3619 51.8108 33.1379 52.1524 33.0459C52.494 32.9539 52.8581 33.0013 53.1647 33.1778C53.4713 33.3543 53.6952 33.6453 53.7872 33.9868C53.8792 34.3284 53.8318 34.6925 53.6553 34.9991L44.446 50.9938C44.3587 51.1456 44.2424 51.2787 44.1037 51.3856C43.9649 51.4924 43.8065 51.5709 43.6374 51.6165C43.4684 51.6622 43.292 51.674 43.1183 51.6515C42.9447 51.6289 42.7772 51.5724 42.6253 51.4851C42.4735 51.3978 42.3404 51.2815 42.2336 51.1428C42.1267 51.004 42.0482 50.8456 42.0026 50.6766C41.957 50.5075 41.9451 50.3311 41.9677 50.1574C41.9902 49.9838 42.0467 49.8163 42.134 49.6645L51.3433 33.6685ZM39.8327 53.6671C40.4993 52.3338 44.4993 51.0005 43.166 53.2938C42.4426 54.5307 41.7168 55.7663 40.9887 57.0005C40.8122 57.3071 40.5212 57.531 40.1796 57.623C39.8381 57.715 39.4739 57.6676 39.1673 57.4911C38.8608 57.3147 38.6368 57.0236 38.5448 56.6821C38.4528 56.3405 38.5002 55.9764 38.6767 55.6698L39.8327 53.6671ZM46.6767 34.9991C46.5002 34.6925 46.4528 34.3284 46.5448 33.9868C46.6368 33.6453 46.8608 33.3543 47.1673 33.1778C47.4739 33.0013 47.8381 32.9539 48.1796 33.0459C48.5212 33.1379 48.8122 33.3619 48.9887 33.6685L51.3127 37.7071C51.4028 37.859 51.4619 38.0272 51.4865 38.2021C51.5111 38.3769 51.5007 38.5549 51.456 38.7258C51.4112 38.8966 51.333 39.0568 51.2258 39.1972C51.1186 39.3375 50.9846 39.4551 50.8316 39.5433C50.6786 39.6314 50.5096 39.6882 50.3344 39.7105C50.1592 39.7328 49.9813 39.72 49.8111 39.673C49.6409 39.626 49.4817 39.5456 49.3428 39.4366C49.204 39.3275 49.0881 39.192 49.002 39.0378L46.6767 34.9991ZM51.8327 44.3338C50.6353 42.3338 51.8327 38.3338 52.7873 40.3285L61.654 55.6671C61.8249 55.9732 61.8684 56.3343 61.775 56.6722C61.6817 57.0101 61.459 57.2976 61.1552 57.4725C60.8514 57.6475 60.491 57.6957 60.1519 57.6069C59.8128 57.518 59.5223 57.2992 59.3433 56.9978L51.8327 44.3338Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_950_676",
    x: 0.5,
    y: 0,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_950_676"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_950_676",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstore);
export default __webpack_public_path__ + "static/media/Appstore.3a7b21bda56726e1085b11e926e4019d.svg";
export { ForwardRef as ReactComponent };